import { render, staticRenderFns } from "./LatestMovements.vue?vue&type=template&id=ae78bae8&"
import script from "./LatestMovements.vue?vue&type=script&lang=js&"
export * from "./LatestMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports